import { render } from "./UserResetPassword.vue?vue&type=template&id=45d54b01&scoped=true"
import script from "./UserResetPassword.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserResetPassword.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserResetPassword.vue?vue&type=style&index=0&id=45d54b01&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d54b01"]])

export default __exports__